<template>
    <div id="catalog">
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            <script type="application/ld+json">
                {{JSON.stringify(breadcrumbSchema)}}
            </script>
            <div class="row">
                <div class="col-xl-3">
                    <catalog-categories class="mb-32" v-if="categories_mobile"/>
<!--                    <transition name="fade-left-enter">-->
<!--                        <catalog-filter @close_filter="closeFilter" v-if="filter_mobile"></catalog-filter>-->
<!--                    </transition>-->
                </div>
                <div class="col-xl-9 position-relative">
                    <h1>{{this.seo_name}} </h1> <!-- {{this.filter.state.active_category_name}} -->
                    <div class="title-3">Мы сделаем пересчет цен <router-link to="/rules/skidki" class="font-500 small color-text-grey">Как получить скидку больше?</router-link></div>
                    <p>Выберите дату, когда вам потребуется техника в аренду, а также выберите,
                        когда планируете ее сдать и получите новые цены с учетом скидки за весь период аренды</p>
                    <div class="mb-12 catalog--sort-container">
                        <button class="button btn-small btn-v1" v-b-modal.modalCalendar>
                            <span v-if="store.rate.count == 0">Выбрать</span>
                            <span v-else>Изменить</span>
                            период аренды
                        </button>

                        <div class="h5 d-flex align-items-end mb-0">
                            <div class="pr-2">Выбрано:</div>
                            <div v-if="store.rate.value == 1 && store.rate.count !== 0">
                                {{store.rate.count}}
                                <span v-if="store.rate.count > 1">часа</span>
                                <span v-else>час</span>
                            </div>
                            <div v-if="store.rate.value == 2 && store.rate.count !== 0" class="d-flex">
                                <div class="pr-1">{{store.rate.count}} сут.</div>
                                <div v-if="store.state.timeStart.HH && store.state.timeEnd.HH && store.state.timeStart.mm && store.state.timeEnd.mm">
                                    ({{displayDates}})
                                </div>
                            </div>
                            <div v-if="store.rate.count == 0" class="font-500">0 сут.</div>
                        </div>

                        <!--                        <div class="calendar-container">-->
                        <!--                            <div class="cursor-pointer icon-link d-flex align-items-center">-->
                        <!--                                <h5 class="mb-0 d-flex">-->
                        <!--                                    Период аренды:-->
                        <!--                                    <span class="font-400 pl-2"> {{displayDates}}</span>-->
                        <!--                                    <div  class="font-400 pl-2" v-if="store.rate.value == 1 && store.rate.count !== 0">-->
                        <!--                                        ({{store.rate.count}}-->
                        <!--                                        <span v-if="store.rate.count > 1">часа</span>-->
                        <!--                                        <span v-else>час</span>)-->
                        <!--                                    </div>-->
                        <!--                                    <div class="font-400 pl-1" v-if="store.rate.value == 2 && store.rate.count !== 0">-->
                        <!--                                        ({{store.rate.count}} сут.)-->
                        <!--                                    </div>-->
                        <!--                                </h5>-->
                        <!--                                <img src="/svg/select.svg" alt="">-->
                        <!--                        </div>-->
                        <!--                            <calendar-app class="calendar"></calendar-app>-->
                        <!--                        </div>-->
                    </div>

                    <div class="d-flex flex-wrap align-items-start justify-content-between mb-24">

                            <div class="catalog-sorting">
                                <multiselect v-model="sorting"
                                             :options="sort_options"
                                             label="title"
                                             trackBy="title"
                                             placeholder="Сначала новые"
                                             selectedLabel=""
                                             selectLabel=""
                                             deselectLabel=""
                                             :allowEmpty="false"
                                             :searchable="false">
                                </multiselect>
                            </div>
                            <div class="catalog-filters-header">
                                <div class="catalog-filters-header-title cursor-pointer d-flex " :class="{'active': show_all_filters }" @click="show_all_filters = !show_all_filters">
                                    <div class="catalog-filters-header-title-text">
                                        <span>Все фильтры</span>
                                    </div>
                                    <span class="icon-category"></span>
                                </div>
                            </div>
<!--                                <div @click="showFilter()"><img src="/svg/filter.svg" alt=""></div>-->


<!--                        <div class="pr-md-5">-->

<!--                            <div-->
<!--                                v-if="filter.filter.brands && filter.show_filter_brand || filter.filter.price_from || filter.filter.price_to-->
<!--                                    || filter.filter.camera_types && filter.show_camera_type || filter.filter.matrix_sizes && filter.show_matrix_size-->
<!--                                    || filter.filter.lens_types && filter.show_lens_type || filter.filter.bayonets && filter.show_bayonet-->
<!--                                    || filter.filter.maximum_apertures && filter.show_maximum_aperture || filter.filter.focal_lengths && filter.show_focal_length-->
<!--                                    || filter.filter.compatibilities && filter.show_compatibility-->
<!--                                    || filter.filter.by_temperatures && filter.show_by_temperature-->
<!--                                    || filter.filter.light_types && filter.show_light_type-->
<!--                                    || filter.filter.LEDs && filter.show_LED "-->
<!--                                class="show_filter_brand">-->

<!--                                <div v-if="filter.filter.brands && filter.show_filter_brand"-->
<!--                                     v-for="item in filter.filter.brands" @click="removeBrand(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.camera_types && filter.show_camera_type"-->
<!--                                     v-for="item in filter.filter.camera_types" @click="removeCameraType(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.matrix_sizes && filter.show_matrix_size"-->
<!--                                     v-for="item in filter.filter.matrix_sizes" @click="removeMatrixSize(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.lens_types && filter.show_lens_type"-->
<!--                                     v-for="item in filter.filter.lens_types" @click="removeLensType(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.bayonets && filter.show_bayonet"-->
<!--                                     v-for="item in filter.filter.bayonets" @click="removeBayonet(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.maximum_apertures && filter.show_maximum_aperture"-->
<!--                                     v-for="item in filter.filter.maximum_apertures" @click="removeMaximumAperture(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.focal_lengths && filter.show_focal_length"-->
<!--                                     v-for="item in filter.filter.focal_lengths" @click="removeFocalLength(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.compatibilities && filter.show_compatibility"-->
<!--                                     v-for="item in filter.filter.compatibilities" @click="removeCompatibility(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.by_temperatures && filter.show_by_temperature"-->
<!--                                     v-for="item in filter.filter.by_temperatures" @click="removeByTemperature(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.light_types && filter.show_light_type"-->
<!--                                     v-for="item in filter.filter.light_types" @click="removeLightType(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.LEDs && filter.show_LED"-->
<!--                                     v-for="item in filter.filter.LEDs" @click="removeLED(item)"-->
<!--                                     class="show_filter_brand__item">-->
<!--                                    <span>{{item.name}}</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.price_from" class="show_filter_brand__item"-->
<!--                                     @click="removePriceFrom()">-->
<!--                                    <span>от {{filter.filter.price_from}} RUB</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->

<!--                                <div v-if="filter.filter.price_to" class="show_filter_brand__item"-->
<!--                                     @click="removePriceTo()">-->
<!--                                    <span>до {{filter.filter.price_to}} RUB</span>-->
<!--                                    <img src="/svg/close-small-dark.svg" alt="" class="cursor-pointer icon-link">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

                    </div>

                    <div class="mb-32 catalog-filters-body" v-if="show_all_filters">
                        <div class="catalog-filter-card d-flex flex-wrap">
                            <div v-if="brands && brands.length > 0" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16">Название бренда</div>-->
                                <div class="mb-40">
                                    <div class="brands-container">
                                        <multiselect v-model="filter_brands"
                                                     :options="brands"
                                                     label="name"
                                                     multiple
                                                     trackBy="name"
                                                     placeholder="Название бренда"
                                                     selectedLabel=""
                                                     selectLabel=""
                                                     deselectLabel=""
                                                     :allowEmpty="true"
                                                     :searchable="true">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>

                            <div v-if="cameraTypes && cameraTypes.length > 0 && show_camera_type == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16">-->
<!--                                    <span>Типы камер</span>-->
<!--                                </div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_camera_types"
                                                         :options="cameraTypes"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="Типы камер"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="matrixSizes && matrixSizes.length && show_matrix_size == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16" >Размер матрицы</div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_matrix_sizes"
                                                         :options="matrixSizes"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="Размер матрицы"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="lensTypes && lensTypes.length && show_lens_type == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16" >Тип объектива</div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_lens_types"
                                                         :options="lensTypes"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="Тип объектива"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div v-if="bayonets && bayonets.length && show_bayonet == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16" >Байонет</div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_bayonets"
                                                         :options="bayonets"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="Байонет"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="maximumApertures && maximumApertures.length && show_maximum_aperture == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16" >Максимальная диафрагма</div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_maximum_apertures"
                                                         :options="maximumApertures"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="Максимальная диафрагма"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="focalLengths && focalLengths.length && show_focal_length == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16" >Фокусное расстояние</div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_focal_lengths"
                                                         :options="focalLengths"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="Фокусное расстояние"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="compatibilities && compatibilities.length && show_compatibility == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16" >Совместимость</div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_compatibilities"
                                                         :options="compatibilities"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="Совместимость"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="byTemperatures && byTemperatures.length && show_by_temperature == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16" >По температуре</div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_by_temperatures"
                                                         :options="byTemperatures"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="По температуре"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="lightTypes && lightTypes.length && show_light_type == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16" >Тип света</div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_light_types"
                                                         :options="lightTypes"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="Тип света"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="LEDs  && LEDs.length && show_LED == true" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
<!--                                <div class="h5 mb-16" >Светодиодный</div>-->
                                <div class="brands-container">
                                    <div class="mb-12">
                                        <div class="brands-container">
                                            <multiselect v-model="filter_LEDs"
                                                         :options="LEDs"
                                                         label="name"
                                                         multiple
                                                         trackBy="name"
                                                         placeholder="Светодиодный"
                                                         selectedLabel=""
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :allowEmpty="true"
                                                         :searchable="true">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16" v-if="max_price">
                                <div class="h5" >Цена, руб.</div>
                                <div class="price-container d-flex justify-content-between">
                                    <input type="text" v-model="value_slider[0]" class="input-box" placeholder="Цена, от">
                                    <input type="text" v-model="value_slider[1]" :max="max_price" class="input-box" placeholder="Цена, до">
                                </div>
                                <vue-slider v-model="value_slider" :lazy="true" :max="max_price"></vue-slider>
                            </div>

                            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-16">
                                <button class="button btn-small btn-v2 w-100" @click="getProducts()">
                                    Показать товары
                                </button>

                                <div class="reset-button" @click="clearFilter()">
                                    <div class="h6">Сбросить фильтр</div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="mb-32" v-if="!statusFilter && categories_nova" v-for="category in categories_nova" >
                        <div class="d-flex justify-content-between mb-32">
                            <span class="title-1 mb-0">{{category.title}}</span>
                            <div class="title-4 mb-0 d-none d-sm-block"><router-link class="link-catalog" :to="'/catalog/category/' + category.cat_slug">Перейти в каталог</router-link></div>
                        </div>
                        <div class="catalog-container">
                            <div class="news-product" v-if="category.subcategories">
                                <carousel :responsive="{0:{items:2,nav:false,margin:7,dots:true},
                    535:{items:3,nav:false,margin:7,dots:true},
                    820:{items:4,nav:false,margin:7,dots:true},
                    991:{items:5,nav:false,margin:7,dots:true},
                    1200:{items:6,nav:true,margin:7,dots:false}}">
                                    <sub-category-nova-card v-for="(item, i) in category.subcategories" :key="i" :item="item" :slug="category.cat_slug"></sub-category-nova-card>
                                </carousel>
                            </div>
                        </div>
                    </div>

                    <div class="mb-32" v-if="!statusFilter && category_nova">
                        <div class="d-flex justify-content-between mb-32">
                            <span class="title-1 mb-0">{{category_nova.title}}</span>
                        </div>
                        <div class="catalog-container">
                            <div class="news-product" v-if="category_nova.subcategories">
                                <carousel :responsive="{0:{items:2,nav:false,margin:7,dots:true},
                    535:{items:3,nav:false,margin:7,dots:true},
                    820:{items:4,nav:false,margin:7,dots:true},
                    991:{items:5,nav:false,margin:7,dots:true},
                    1200:{items:6,nav:true,margin:7,dots:false}}">
                                    <sub-category-nova-card v-for="(item, i) in category_nova.subcategories" :key="i" :item="item" :slug="category_nova.cat_slug"></sub-category-nova-card>
                                </carousel>
                            </div>
                        </div>
                    </div>

                    <div class="row catalog-row mb-32" v-if="filter.state.products && filter.state.products.length > 0">
                        <div class="col-6 col-sm-4 col-lg-3 mb-10" v-for="item in filter.state.products">
                            <catalog-card :item="item"></catalog-card>
                        </div>
                    </div>

                    <div v-if="filter.state.products && filter.state.products.length < 1">
                        <span class="h5">К сожалению, нам не удалось найти товары, подходящие под Ваш запрос.</span>
                    </div>

                    <div v-if="filter.state.products && filter.state.count > 16">
                        <b-pagination-nav
                            @page-click="pageClick"
                            :link-gen="linkGen"
                            :number-of-pages="totalRows"
                            use-router>
                        </b-pagination-nav>
                    </div>

                    <div class="mt-5" v-if="seo_text && !hideSeoText">
                        <p v-html="seo_text"></p>
                    </div>

                    <div v-if="filter.state.loading" class="loading-box">
                        <b-spinner></b-spinner>
                    </div>

                </div>
            </div>
        </div>


        <modal-calendar></modal-calendar>

        <!--        <add-basket-modal></add-basket-modal>-->
    </div>

</template>


<script>
    import Multiselect from 'vue-multiselect';
    import filter from "../../../services/filter";

    import store from '../../../services/data';
    import order from '../../../services/order';
    import moment from 'moment';
    import carousel from "vue-owl-carousel";

    export default {
        components: {Multiselect, carousel},
        data() {
            return {
                show_all_filters: false,
                filter: filter,
                perPage: 20,
                currentPage: 0,
                sorting: {type: null, title: 'Сначала новые'},

                sort_options: [
                    {type: null, title: 'Сначала новые'},
                    {type: 'asc', title: 'Сначала дешевые'},
                    {type: 'desc', title: 'Сначала дорогие'},
                ],

                store: store,
                order: order,

                categories_mobile: true,
                filter_mobile: true,
                windowWidth: null,
                seo_text: null,
                seo_name: null,

                category_nova: null,
                categories_nova: null,

                value_slider: [0, 1200],
                brand_search: null,
                filter_brands: [],
                filter_camera_types: [],
                filter_matrix_sizes: [],
                filter_lens_types: [],
                filter_bayonets: [],
                filter_maximum_apertures: [],
                filter_focal_lengths: [],
                filter_compatibilities: [],
                filter_by_temperatures: [],
                filter_light_types: [],
                filter_LEDs: [],
                show_camera_type: false,
                show_matrix_size: false,
                show_lens_type: false,
                show_bayonet: false,
                show_maximum_aperture: false,
                show_focal_length: false,
                show_compatibility: false,
                show_by_temperature: false,
                show_light_type: false,
                show_LED: false,
            }
        },
        mounted() {
            this.$store.dispatch('fetchBrands', {'url': this.$route.path});
            this.$store.dispatch('fetchCatFilters', {'url': this.$route.path});
            if (this.$route.query.page) this.filter.filter.page = this.$route.query.page;
            else this.filter.filter.page = 1;
            this.init();
            this.filter.getBreadcrumb(null, null, this.$route.name);

            this.windowWidth = window.innerWidth;
            if (this.windowWidth < 1200) {
                this.categories_mobile = false;
                this.filter_mobile = false;
            } else {
                this.categories_mobile = true;
                this.filter_mobile = true;
            }
            this.handleWindowResize();
            window.addEventListener('resize', this.handleWindowResize);
        },
        computed: {
            hideSeoText() {
                return this.filter.filter.page > 1 || this.$route.query.page > 1;
            },
            statusFilter() {
              if (this.filter.show_filter_brand || this.filter.show_camera_type ||
                  this.filter.show_matrix_size || this.filter.show_lens_type ||
                  this.filter.show_bayonet || this.filter.show_maximum_aperture ||
                  this.filter.show_focal_length || this.filter.show_compatibility ||
                  this.filter.show_by_temperature || this.filter.show_light_type ||
                  this.filter.show_LED || this.filter.filter.price_from || this.filter.filter.price_to)
                  return true;
              return false;
            },
            totalRows() {
                return Math.ceil(this.filter.state.count / this.perPage)
            },
            displayDates() {
                const timeStart = {hour: this.store.state.timeStart.HH, minute: this.store.state.timeStart.mm, second: 0, millisecond: 0};
                const timeEnd = {hour: this.store.state.timeEnd.value, minute: this.store.state.timeEnd.mm, second: 0, millisecond: 0};
                const from = moment(this.store.state.dates.start).set(timeStart).format('DD.MM.YY');
                const to = moment(this.store.state.dates.end).set(timeEnd).format('DD.MM.YY');
                if (this.store.state.dates.start == null || this.store.state.dates.end == null) {
                    return 'Выберите дату...';
                } else {
                    return `${from} - ${to}`;
                }
            },

            breadcrumb() {
                return this.filter.state.breadcrumb
            },

            breadcrumbSchema() {
                const breadcrumbItems = this.filter.state.breadcrumb.map((item, index) => {
                    const itemTo = item.to && item.to.path ? item.to.path : '/';
                    const itemUrl = this.getAbsoluteUrl(itemTo); // Get the absolute URL

                    return {
                        '@type': 'ListItem',
                        'position': index + 1,
                        'item': {
                            '@id': itemUrl,
                            'name': item.text
                        }
                    };
                });

                // Adding a grid to the last breadcrumb element
                if (breadcrumbItems.length > 0) {
                    breadcrumbItems[breadcrumbItems.length - 1].item['@id'] += '#';
                }

                return {
                    '@context': 'http://schema.org',
                    '@type': 'BreadcrumbList',
                    'itemListElement': breadcrumbItems
                };
            },

            brands() {
                return this.makeOptions(this.$store.getters.getBrands);
            },
            cameraTypes() {
                return this.makeOptions(this.$store.getters.getCameraTypes);
            },
            matrixSizes() {
                return this.makeOptions(this.$store.getters.getMatrixSizes);
            },
            lensTypes() {
                return this.makeOptions(this.$store.getters.getLensTypes);
            },
            bayonets() {
                return this.makeOptions(this.$store.getters.getBayonets);
            },
            maximumApertures() {
                return this.makeOptions(this.$store.getters.getMaximumApertures);
            },
            focalLengths() {
                return this.makeOptions(this.$store.getters.getFocalLengths);
            },
            compatibilities() {
                return this.makeOptions(this.$store.getters.getCompatibilities);
            },
            byTemperatures() {
                return this.makeOptions(this.$store.getters.getByTemperatures);
            },
            lightTypes() {
                return this.makeOptions(this.$store.getters.getLightTypes);
            },
            LEDs() {
                return this.makeOptions(this.$store.getters.getLEDs);
            },
            max_price() {
                return this.$store.getters.getMaxPrice;
            },
        },
        watch: {
            $route() {
                this.resetFilter();
                this.$store.dispatch('fetchBrands', {'url': this.$route.path});
                this.$store.dispatch('fetchCatFilters', {'url': this.$route.path});
                if (this.$route.query.page) this.filter.filter.page = this.$route.query.page;
                else this.filter.filter.page = 1;
                if (this.$route.name === 'pages-catalog' || this.$route.name === 'pages-catalog-new') {
                    this.filter.getBreadcrumb(null, null, this.$route.name);
                    this.filter.state.active_category = null;
                    this.filter.state.active_category_name = null;
                }
                else this.filter.getBreadcrumb(null, null, this.$route.name);
                this.init();
            },
            sorting() {
                if (this.sorting) {
                    this.filter.filter.sorting = this.sorting.type;
                    this.filter.getProducts()
                }
            },
            'filter.filter.sorting'() {
                if (!this.filter.filter.sorting) this.sorting = {type: null, title: 'Сначала новые'};
            },
            displayDates() {
                this.store.getItemBasketData();
            },
            'filter.state.active_category_name'() {
                this.metaInfo()
            },
            'cameraTypes'() {
                if (this.cameraTypes != null && Object.keys(this.cameraTypes).length > 0) this.show_camera_type = true;
                else this.show_camera_type = false;
            },
            'matrixSizes'() {
                if (this.matrixSizes != null && Object.keys(this.matrixSizes).length > 0) this.show_matrix_size = true;
                else this.show_matrix_size = false;
            },
            'lensTypes'() {
                if (this.lensTypes != null && Object.keys(this.lensTypes).length > 0) this.show_lens_type = true;
                else this.show_lens_type = false;
            },
            'bayonets'() {
                if (this.bayonets != null && Object.keys(this.bayonets).length > 0) this.show_bayonet = true;
                else this.show_bayonet = false;
            },
            'maximumApertures'() {
                if (this.maximumApertures != null && Object.keys(this.maximumApertures).length > 0) this.show_maximum_aperture = true;
                else this.show_maximum_aperture = false;
            },
            'focalLengths'() {
                if (this.focalLengths != null && Object.keys(this.focalLengths).length > 0) this.show_focal_length = true;
                else this.show_focal_length = false;
            },
            'compatibilities'() {
                if (this.compatibilities != null && Object.keys(this.compatibilities).length > 0) this.show_compatibility = true;
                else this.show_compatibility = false;
            },
            'byTemperatures'() {
                if (this.byTemperatures != null && Object.keys(this.byTemperatures).length > 0) this.show_by_temperature = true;
                else this.show_by_temperature = false;
            },
            'lightTypes'() {
                if (this.lightTypes != null && Object.keys(this.lightTypes).length > 0) this.show_light_type = true;
                else this.show_light_type = false;
            },
            'LEDs'() {
                if (this.LEDs != null && Object.keys(this.LEDs).length > 0) this.show_LED = true;
                else this.show_LED = false;
            },
            'filter.filter.price_from'() {
                if (!this.filter.filter.price_from) this.value_slider = [0, this.filter.filter.price_to];
            },
            'filter.filter.price_to'() {
                if (!this.filter.filter.price_to) this.value_slider = [this.filter.filter.price_from, this.max_price];
            },
            value_slider() {
                if (this.value_slider[0] > this.max_price) {
                    this.value_slider[0] = this.max_price - 1;
                    this.value_slider[1] = this.max_price;
                }
                if (this.value_slider[1] > this.max_price) {
                    this.value_slider[1] = this.max_price;
                }
            }
        },
        methods: {
            getAbsoluteUrl(path) {
                const currentDomain = window.location.origin;
                return currentDomain + path;
            },
            makeOptions(object){
                let options = [];
                if (object != undefined && object != null) {
                    let values = Object.values(object);
                    if (values.length > 0) {
                        values.forEach(item => options.push({name: item.name, id: item.id}));
                    }
                }
                return options;
            },

            init() {
                this.category_nova = null;
                this.categories_nova = null;

                if (this.filter.filter.url != this.$route.path) {
                    this.filter.resetFilter();
                    this.filter.filter.url = this.$route.path;
                }

                if(this.$route.path == '/catalog'){
                    let defaultTitle = 'Каталог фото и видео техники и оборудования для проката в Минске';
                    let defaultDesc = 'В нашем каталоге фото и видео техники и оборудования представлены лучшие бренды и производители в своей категории. Canon, Nikon, Sony, Panasonic, Fujifilm, Freefly, Blackmagic, RED и многие другие. ';
                    this.getSeoInfo('catalog', null, defaultTitle, defaultDesc);

                    axios.get('/api/catalog/main-page')
                        .then(response => {
                            this.categories_nova = response.data.categories_nova;
                        })
                } else if(this.$route.path == '/catalog/new'){
                    let defaultTitle = 'Новинки фото и видео техники и оборудования для проката в Минске';
                    let defaultDesc = 'В нашем каталоге фото и видео техники и оборудования представлены лучшие бренды и производители в своей категории. Canon, Nikon, Sony, Panasonic, Fujifilm, Freefly, Blackmagic, RED и многие другие.';
                    this.getSeoInfo('catalog/new', null, defaultTitle, defaultDesc);
                } else if (this.$route.name == 'pages-catalog-category') {
                    let params = {
                        category: this.$route.params.category,
                    };
                    axios.post('/api/catalog/children-page', params)
                        .then(response => {
                            this.category_nova = response.data.category_nova;
                        })
                }
                this.filter.getProducts();
            },

            setMetaOg(title, desc, ogImage) {
                document.querySelector('meta[property="og:url"]').setAttribute("content",  window.location.href);
                document.querySelector('meta[property="og:title"]').setAttribute("content",  title);
                document.querySelector('meta[property="og:type"]').setAttribute("content",  'website');
                ogImage = ogImage != null ? ogImage : '';
                document.querySelector('meta[property="og:image"]').setAttribute("content",  ogImage);
                //document.querySelector('meta[name="image"]').setAttribute("content", '/storage/' + image);
                document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
            },
            linkGen(pageNum) {
                return pageNum == 1 ? '?' : `?page=${pageNum}`;
            },
            pageClick(bvEvent, page) {
                this.filter.filter.page = page;
            },
            removeBrand(item) {
                this.filter.removeBrand(item);
            },
            removeCameraType(item) {
                this.filter.removeCameraType(item);
            },
            removeMatrixSize(item) {
                this.filter.removeMatrixSize(item);
            },
            removeLensType(item) {
                this.filter.removeLensType(item);
            },
            removeBayonet(item) {
                this.filter.removeBayonet(item);
            },
            removeMaximumAperture(item) {
                this.filter.removeMaximumAperture(item);
            },
            removeFocalLength(item) {
                this.filter.removeFocalLength(item);
            },
            removeByTemperature(item) {
                this.filter.removeByTemperature(item);
            },
            removeCompatibility(item){
                this.filter.removeCompatibility(item);
            },
            removeLightType(item) {
                this.filter.removeLightType(item);
            },
            removeLED(item) {
                this.filter.removeLED(item);
            },
            removePriceFrom() {
                this.filter.filter.price_from = null;
                this.filter.getProducts();

            },
            removePriceTo() {
                this.filter.filter.price_to = null;
                this.filter.getProducts();
            },
            showFilter() {
                this.filter_mobile = true;
                document.body.style.overflow = 'hidden'
            },
            closeFilter() {
                this.filter_mobile = false;
                document.body.style.overflow = 'visible'
            },
            handleWindowResize() {

                let changeWidth = false;
                if (window.innerWidth !== this.windowWidth) changeWidth = true;
                this.windowWidth = window.innerWidth;
                if (this.windowWidth < 1200 && changeWidth) {
                    this.categories_mobile = false;
                    this.filter_mobile = false;
                } else if (this.windowWidth < 1200 && !changeWidth) {

                } else {
                    this.categories_mobile = true;
                    this.filter_mobile = true;
                }
            },
            getSeoInfo(path, type, titleDefault, descDefault){
                let url = '/api/seo';

                let params = {
                    url: path,
                    type: type
                };

                axios.post(url, params)
                    .then(response => {
                        let seoInfo = response.data.seoInfo;
                        this.seo_text = seoInfo.seo_text;

                        this.seo_name = seoInfo?.seo_h1 && seoInfo.seo_h1 ? seoInfo.seo_h1 : seoInfo.name;

                        document.title = seoInfo?.seo_title
                            ? seoInfo.seo_title
                            : (seoInfo?.seo_h1 || seoInfo?.name)
                                ? (seoInfo.seo_h1 ?? seoInfo.name) + ' взять в аренду в Москве, цена'
                                : titleDefault;

                        let ogTitle = seoInfo?.seo_title
                            ? seoInfo.seo_title
                            : (seoInfo?.seo_h1 || seoInfo?.name)
                                ? (seoInfo.seo_h1 ?? seoInfo.name)
                                : titleDefault;

                        let desc = seoInfo?.seo_desc
                            ? seoInfo.seo_desc
                            : (seoInfo?.seo_h1 || seoInfo?.name)
                                ? (seoInfo.seo_h1 ?? seoInfo.name) + ' взять в аренду в Москве. ⭐️ Без залога. ⭐️ Только профессиональное оборудование. ⭐️ Доставка по всей Москве.'
                                : descDefault;

                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);

                        let ogImage = response.data.ogImage;

                        this.setMetaOg(ogTitle, desc, ogImage);
                        this.setDocTitleAndDescr();
                    })
                    .catch(error => {
                        if (error) this.loading = false;
                    })
            },
            setDocTitleAndDescr() {
                if (this.filter.filter.page > 1) {
                    let title = document.title;
                    let description = document.querySelector('meta[name="description"]').getAttribute("content");
                    title += ', Cтраница -' + this.filter.filter.page;
                    description += ', Cтраница -' + this.filter.filter.page
                    console.log(title, 'title');
                    console.log(description, 'description')
                    document.title = title;
                    document.querySelector('meta[name="description"]').setAttribute("content", description);
                    document.querySelector('meta[name="robots"]').setAttribute("content",  'noindex, follow');
                } else {
                    document.querySelector('meta[name="robots"]').setAttribute("content",  'index, follow');
                }
            },
            getProducts() {
                this.filter.filter.price_from = this.value_slider[0];
                this.filter.filter.price_to = this.value_slider[1];
                this.filter.filter.brands = this.filter_brands;
                this.filter.filter.camera_types = this.filter_camera_types;
                this.filter.filter.matrix_sizes = this.filter_matrix_sizes;
                this.filter.filter.lens_types = this.filter_lens_types;
                this.filter.filter.bayonets = this.filter_bayonets;
                this.filter.filter.maximum_apertures = this.filter_maximum_apertures;
                this.filter.filter.focal_lengths = this.filter_focal_lengths;
                this.filter.filter.compatibilities = this.filter_compatibilities;
                this.filter.filter.by_temperatures = this.filter_by_temperatures;
                this.filter.filter.light_types = this.filter_light_types;
                this.filter.filter.LEDs = this.filter_LEDs;
                this.filter.filter.page = 1;
                if (this.$router.query) this.$router.replace({'query': null});
                this.filter.getProducts();
                document.getElementById('app').scrollIntoView({behavior: "auto"});
                if (window.innerWidth < 1200) this.$emit('close_filter', true);
            },

            resetFilter() {
                this.value_slider = [0, 1200];
                this.brand_search = null;
                this.filter_brands = [];
                this.filter_camera_types = [];
                this.filter_matrix_sizes = [];
                this.filter_lens_types = [];
                this.filter_bayonets = [];
                this.filter_maximum_apertures = [];
                this.filter_focal_lengths = [];
                this.filter_compatibilities = [];
                this.filter_by_temperatures = [];
                this.filter_light_types = [];
                this.filter_LEDs = [];
            },

            clearFilter() {
                this.resetFilter();
                this.getProducts();
            },

            closeFilter() {
                this.$emit('close_filter', true);
            },

            metaInfo() {
                if (this.$route.name === 'pages-catalog-category' || this.$route.name === 'pages-catalog-category-subcategory') {
                    let defaultTitle = this.filter.state.active_category_name + ' в каталоге оборудования для проката в Москве';
                    let defaultDesc = 'В нашем каталоге фото и видео техники и оборудования представлены лучшие бренды и производители в своей категории. Canon, Nikon, Sony, Panasonic, Fujifilm, Freefly, Blackmagic, RED и многие другие.';
                    this.getSeoInfo(this.$route.path, 'category', defaultTitle, defaultDesc);
                }
            }
        }

    }
</script>
